import nProgress from 'nprogress';

export const progressBarStart = () => nProgress.start();

export const progressBarDone = () => nProgress.done();

export const showProgressBar = () => {
  progressBarStart();
  progressBarDone();
};
